import { type Theme } from "~/common/mui";

export const vendorAndIframeStyles = (theme: Theme) => ({
  "body.template-pages-layout-forkPageLayout > main > footer > .jsp__footer__bottom": {
    display: "none",
  },
  "#cadIframe": {
    [theme.breakpoints.up("tablet")]: {
      height: "650px",
    },
  },
  "#configuratorIframe, #calcIframe": {
    height: "1050px",
    [theme.breakpoints.down("tablet")]: {
      maxHeight: "80vh",
    },
  },
  "#mmIframe": {
    height: "800px",
    [theme.breakpoints.down("tablet")]: {
      maxHeight: "80vh",
    },
  },
  ".gm-svpc": {
    "& div": {
      width: "40px",
      height: "40px",
    },
  },
  ".scha__sp__map .gm-style-moc": {
    zIndex: "1 !important",
  },
});
